export default {
  methods: {
    closeKebabMenu({ _id: id }) {
      this.$bus.$emit('closeKebabMenu', { _id: id });
    },
  },
};
